const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://q3rnvxdscb.execute-api.ap-southeast-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://q554hzcj82.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.ozminerals.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.ozminerals.forwoodsafety.com',
    WEBSOCKET: 'wss://wg3taxg1u2.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;